import { Base } from '@studiometa/js-toolkit';
import Panel from '../Panel.js';
import PanelPickup from '../PanelPickup.js';
import PanelSize from '../PanelSize.js';
import ProductStickyBar from './ProductStickyBar.js';
import PanelVariants from '../PanelVariants.js';

/**
 * Popin Newsletter class.
 * @todo refactor and explode structure & component
 */
export default class Product extends Base {
  timeout = null;

  firstScroll = true;

  breakpoints = ['xxs', 'xs'];

  static config = {
    name: 'Product',
    refs: [
      'variants[]',
      'variantPicture',
      'subtitle',
      'price',
      'gallery',
      'addToCart',
      'galleryItems[]',
      'galleryDots[]',
      'dotsWrapper',
    ],
    components: {
      Panel,
      PanelPickup,
      PanelVariants,
      PanelSize,
      ProductStickyBar,
    },
    options: {
      subtitle: {
        default: '',
        type: String,
      },
      price: {
        default: '',
        type: String,
      },
    },
  };

  /**
   *
   */
  mounted() {
    if (this.isMobile) {
      return;
    }

    this.position = 0;
    this.currentDots = this.$refs.galleryDots[this.position];
    this.previousDots = null;

    const observer = new IntersectionObserver(this.checkIntersection.bind(this), {
      threshold: 0.6,
    });

    this.$refs.galleryItems.forEach((target) => {
      observer.observe(target);
    });
  }

  /**
   * Hover on main items
   * @param {object} props Props
   * @param {object} props.event current event
   * @param {object} props.target current element
   * @returns {void}
   */
  onGalleryDotsClick({ event, target }) {
    event.preventDefault();

    const scrollTarget = document.querySelector(target.dataset.index);
    document.documentElement.scrollTo({
      top: scrollTarget.offsetTop + 83,
      behavior: 'smooth',
    });
  }

  /**
   * Check gallery intersection
   * @param  {object} entries
   * @returns {void}
   */
  checkIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.position = entry.target.dataset.position;
        this.previousDots = this.currentDots;
        this.currentDots = this.$refs.galleryDots[this.position];

        this.previousDots.classList.remove('!bg-black');
        if (this.currentDots) {
          this.currentDots.classList.add('!bg-black');
        }
      }
    });
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   */
  scrolled({ y }) {
    if (this.isMobile) {
      return;
    }
    if (this.bottomGallery < this.halfWindow) {
      this.$refs.dotsWrapper.classList.add('-translate-x-12');
      this.firstScroll = true;
      return;
    }

    if (this.firstScroll && y > 50) {
      this.firstScroll = false;
      this.$refs.dotsWrapper.classList.remove('-translate-x-12');
    }

    if (!this.firstScroll && y < 50) {
      this.firstScroll = true;
      this.$refs.dotsWrapper.classList.add('-translate-x-12');
    }
  }

  /**
   *
   */
  onPanelClosePanel() {
    this.checkPanelsState();
  }

  /**
   *
   */
  onPanelSizeClosePanel() {
    this.checkPanelsState();
  }

  /**
   *
   */
  onPanelPickupClosePanel() {
    this.checkPanelsState();
  }

  /**
   * Check if panel is already open and disable Header State changing if true
   */
  checkPanelsState() {
    let changeHeaderState = true;
    this.$children.Panel.forEach((element) => {
      if (element.isOpen) {
        changeHeaderState = false;
      }
    });

    if (this.$children.PanelPickup[0] && this.$children.PanelPickup[0].isOpen) {
      changeHeaderState = false;
    }
    if (this.$children.PanelSize[0].isOpen) {
      changeHeaderState = false;
    }

    if (changeHeaderState) {
      const header = document.querySelector('#main-header');
      setTimeout(() => {
        header.classList.add('z-40');
        header.classList.remove('z-11');
      }, 1000);
    }
  }

  /**
   * Change image on gallery when entering variants
   * @param {object} props
   * @param {HTMLElement} props.target
   */
  onVariantsMouseenter({ target }) {
    if (this.isMobile) {
      return;
    }

    if (this.timeout) {
      clearTimeout(this.timeout);
    }

    const { picture, subtitle, price } = target.dataset;
    this.picture = picture;
    this.price = price;
    this.subtitle = subtitle;
    this.showVariantsElements();
  }

  /**
   *
   */
  onVariantsMouseleave() {
    if (this.isMobile) {
      return;
    }
    this.timeout = setTimeout(() => {
      this.resetVariantsElements();
    }, 500);
  }

  /**
   *
   */
  showVariantsElements() {
    if (this.picture) {
      this.$refs.variantPicture.src = this.picture;
      this.$refs.variantPicture.classList.remove('opacity-0');
      this.$refs.gallery.classList.add('opacity-0');
    }
    this.$refs.price.innerHTML = this.price;
    this.$refs.subtitle.innerHTML = this.subtitle;
  }

  /**
   *
   */
  resetVariantsElements() {
    this.$refs.price.innerHTML = this.$options.price;
    this.$refs.subtitle.innerHTML = this.$options.subtitle;
    this.$refs.gallery.classList.remove('opacity-0');
    this.$refs.variantPicture.classList.add('opacity-0');
  }

  /**
   * Check if device is mobile
   * @returns {boolean}
   */
  get isMobile() {
    return this.breakpoints.includes(this.$services.get('resized').breakpoint);
  }

  /**
   * get bottom of the gallery.
   * @returns {number}
   */
  get bottomGallery() {
    return this.$refs.gallery.getBoundingClientRect().bottom - 150;
  }

  /**
   * get the half of window
   * @returns {number}
   */
  get halfWindow() {
    return window.innerHeight / 2;
  }
}
